import React from 'react'
import style from '../scss/components/ExplainedKeypoints.module.scss'
import Quote from './Quote'
import BrandRow from './BrandRow'
import Column from './Column'

const ExplainedKeypoints = () => {
    return (
        <div className={style.Wrapper}>
            <h3>SalonSecretsi koolitusel saad teada...</h3>
            <BrandRow>
                <Column bottomOffset>
                    <Quote title={'Tipptasemel salongide edu valemi ehk salajase 75 mudeli…'} big>
                        Maailma tippsalongide salanipid, kuidas hoida olemasolevaid ja juurde meelitada uusi kliente,
                        jõuavad Sinuni <strong>23 efektiivse taktika kujul</strong>, mida saad koheselt ka oma salongis rakendada.
                    </Quote>
                </Column>
                <Column bottomOffset>
                    <Quote title={'Kuidas kindlustada püsiklientide kustumatu lojaalsus…'} big>
                        Soovid, et Sinu kalender oleks broneeringuid täis ka siis, kui oma hinnakirja tõstad?
                        Jagame Sinuga <strong>37 järeleproovitud turundusnippi</strong>, mis töötavad iga salongi puhul.
                    </Quote>
                </Column>
            </BrandRow>
            <BrandRow>
                <Column bottomOffset>
                    <Quote title={'Kuidas vältida suurimat, salongi kasvu pärssivat viga…'} big>
                        Üle 85% salongiomanikest (tõenäoliselt ka Sina!) eksivad igapäevaselt ühe salongi kasvatamise kuldreegli vastu,
                        mis maksab neile nende väärtuslikku <strong>aega, raha ja vabadust</strong>.
                    </Quote>
                </Column>
                <Column bottomOffset>
                    <Quote title={'Milline näeb välja ideaalne klienditeekond…'} big>
                        Muuhulgas jagame Sinuga <strong>6 parimat klientide hoidmise ja tagasivõitmise meetodit</strong>, et ükski klient kunagi ära ei vajuks", vaid alati Sinu kasuks otsustaks.
                    </Quote>
                </Column>
            </BrandRow>
            <BrandRow>
                <Column bottomOffset>
                    <Quote title={'Millal, kuhu ja mida sotsiaalmeediasse postitada…'} big>
                        Pärast kursuse läbimist tead täpselt, <strong>milliste postituste tegemist iga hinna eest vältida</strong> ja mida just teha, et <strong>konkurentide seast mängeldes silma paista</strong>.
                    </Quote>
                </Column>
                <Column bottomOffset>
                    <Quote title={'Kuidas suurendada broneeringute arvu ja käivet…'} big>
                        Seejuures <strong>automatiseerides 95% oma tegevustest</strong>, tänu millele saad tegeleda asjadega, mida tõeliselt naudid – iluteenuste osutamise ja salongi kasvatamisega.
                    </Quote>
                </Column>
            </BrandRow>
        </div>
    )
}

export default ExplainedKeypoints
